import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Authentication } from '../services/authentication';
import { AuthHelper } from '../services/authHelper';
import { UserData } from "../shared/models/user.model";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  userData = new UserData();
  private authHelper: AuthHelper
  constructor(auth: AuthHelper,private authentication: Authentication, private router: Router,
    private cookieService: CookieService, private ngZone: NgZone, private route: ActivatedRoute) {
      this.authHelper = auth;
  }

  ngOnInit(): void {
    
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData == null) {
      this.authHelper.login();
    } else {
      this.ngZone.run(() => this.router.navigate(["dashboard"])).then();
    }
  }
}
